var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(434.03 520.84 -520.84 434.03 34.778 -90.0684)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#273498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0074c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00abe7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "matrix(1.17188 0 0 1.17188 -17.6562 -2.73437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m271.1 144.8-31.7 18.3c-.8.5-1.3 1.3-1.3 2.3v15.3c0 .9.5 1.8 1.3 2.2l13.3 7.7c.8.5 1.8.5 2.5 0l54.8-31.6c9.3-5.4 9.3-20.9 0-26.3l-49.2-28.4c-4.2-2.5-9.4-2.5-13.6 0l-49.2 28.4c-4.3 2.4-6.9 6.9-6.9 11.8 0 19 .1 37.9 0 56.8 0 4.9 2.6 9.4 6.9 11.8l49.2 28.4c4.2 2.4 9.4 2.4 13.6 0l49.3-28.4c4.3-2.4 6.9-6.9 6.8-11.8v-24.7l-58.6 33.9c-2.6 1.6-5.9 1.6-8.5 0l-26.2-15.2c-2.7-1.5-4.3-4.3-4.2-7.3v-30.2c0-3 1.6-5.8 4.1-7.3 8.7-5.1 17.5-10.1 26.3-15.2 2.6-1.5 5.9-1.5 8.5 0l13 7.4c.5.3.7 1 .4 1.6-.3.3-.4.4-.6.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254 82.3c-50.1 0-90.7 40.6-90.7 90.7s40.6 90.7 90.7 90.7 90.7-40.6 90.7-90.7-40.6-90.7-90.7-90.7zm17.1 60.6-13-7.4c-2.6-1.5-5.9-1.5-8.5 0-8.7 5.1-17.5 10.1-26.3 15.2-2.6 1.5-4.2 4.3-4.2 7.3v30.2c0 3 1.6 5.9 4.2 7.3l26.2 15.2c2.6 1.6 5.9 1.6 8.5 0l58.6-33.9v24.7c.1 4.9-2.5 9.4-6.7 11.8l-49.2 28.4c-4.2 2.4-9.4 2.4-13.6 0l-49.2-28.4c-4.3-2.4-6.9-6.9-6.9-11.8.1-18.9 0-37.8 0-56.8 0-4.9 2.6-9.4 6.9-11.8l49.2-28.4c4.2-2.5 9.4-2.5 13.6 0l49.3 28.4c9.3 5.4 9.3 20.9 0 26.3l-54.8 31.5c-.8.5-1.8.5-2.5 0l-13.3-7.7c-.8-.4-1.3-1.3-1.3-2.2v-15.3c0-.9.5-1.8 1.3-2.3l31.7-18.3c.5-.3.7-1 .4-1.6-.1-.2-.2-.3-.4-.4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254 45c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128zm17.1 97.9-13-7.4c-2.6-1.5-5.9-1.5-8.5 0-8.7 5.1-17.5 10.1-26.3 15.2-2.6 1.5-4.2 4.3-4.2 7.3v30.2c0 3 1.6 5.9 4.2 7.3l26.2 15.2c2.6 1.6 5.9 1.6 8.5 0l58.6-33.9v24.7c.1 4.9-2.5 9.4-6.7 11.8l-49.2 28.4c-4.2 2.4-9.4 2.4-13.6 0l-49.2-28.4c-4.3-2.4-6.9-6.9-6.9-11.8.1-18.9 0-37.8 0-56.8 0-4.9 2.6-9.4 6.9-11.8l49.2-28.4c4.2-2.5 9.4-2.5 13.6 0l49.3 28.4c9.3 5.4 9.3 20.9 0 26.3l-54.8 31.5c-.8.5-1.8.5-2.5 0l-13.3-7.7c-.8-.4-1.3-1.3-1.3-2.2v-15.3c0-.9.5-1.8 1.3-2.3l31.7-18.3c.5-.3.7-1 .4-1.6-.1-.2-.2-.3-.4-.4z",
    fill: "url(#a)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcash);
export default __webpack_public_path__ + "static/media/ecash.3d2756a87388ef15c20e37e2b7ac8d2f.svg";
export { ForwardRef as ReactComponent };